module.exports = __webpack_public_path__ + "static/media/aurora.75b325e7.svg";